/**
 * Dataroom actions
 */
export const DATAROOM_ACTIONS = {
  FILE_SELECTED: 'file_selected',
  FILE_UPLOADED: 'file_uploaded',
  FILE_UPLOAD_FAILED: 'file_upload_failed',
  FILE_DOWNLOADED: 'file_downloaded',
  FILES_DELETED: 'files_deleted',
  FOLDER_CREATED: 'folder_created',
  FOLDER_DELETED: 'folder_deleted',
  PERMISSION_CHANGED: 'permission_changed',
  SEARCH_PERFORMED: 'search_performed',
  TAB_CHANGED: 'tab_changed',
  SHARE_MODAL_OPENED: 'share_modal_opened',
  SHARE_MODAL_CLOSED: 'share_modal_closed',
  SHARE_LINK_GENERATED: 'share_link_generated',
  SHARE_PERMISSION_CHANGED: 'share_permission_changed',
  PROJECT_CARD_CLICKED: 'project_card_clicked',
} as const;
